import { Navigate } from "react-router-dom"

import { CLIENT_AUTHORIZATION_PLACE, USER_ACCOUNT_LOADING_STATUS } from "./common/constant"
import { ClientLoginForm } from "./ClientLoginForm"
import { getRedirectLink } from "./parseQuery"

import { logEvent } from "utils/helpers"
import { Spinner } from "components/Spinner"
import { PageHeader } from "components/Header/PageHeader"
import { Footer, Layout } from "components"
import { useClientContext } from "modules/ClientAuthorization/common/ClientContext"
import { useDidMount } from "utils/customHooks"
import { isAuthByPromocodePage } from "app/AppRouter/utils"

export function ClientAuthorizationPage() {
    const [{ loading, isVerified }] = useClientContext()

    useDidMount(() => {
        if (isVerified) {
            logEvent({ event: "Client signed in" })
        }
    })

    if (loading !== USER_ACCOUNT_LOADING_STATUS.READY) {
        return (
            <Layout className="profile">
                <Spinner />
            </Layout>
        )
    }

    if (isVerified) {
        return <Navigate to={getRedirectLink() ?? "/my/alter"} replace />
    }

    return (
        <Layout className="profile">
            <PageHeader />
            <ClientLoginForm
                byPromocode={isAuthByPromocodePage()}
                place={CLIENT_AUTHORIZATION_PLACE.MAIN}
            />
            <Footer />
        </Layout>
    )
}
